import React, { useState } from "react";
import { Box } from "@mui/material";
import styles from "./changeStatusComponent.module.scss";
import FooterButtonSection from "../footerSection/FooterButtonSection";
import { StatusEnumValue, statusList } from "../../config/appConfig";
import FormControlLabel from "@mui/material/FormControlLabel";
import StatusText from "../statusText/StatusText";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import { getStatusClassName } from "../../utils/commonFuntion";
import { ReactComponent as RadioIcon } from "../../assets/icons/Radio.svg";
import { ReactComponent as RadioUncheck } from "../../assets/icons/RadioUncheck.svg";
import _ from "lodash";
import i18next from "i18next";
import { updateDealerStatus } from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const ChangeStatusComponent = (props) => {
  const {
    selectionModel,
    setSelectionModal,
    setBulkActionMenuFlag,
    setChangeStatus,
    refreshTable,
  } = props;
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const handleApply = () => {
    updateDealerStatus({
      dealerIds: selectionModel,
      dealer_Status: selectedStatus,
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          refreshTable();
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    setBulkActionMenuFlag(false);
    setChangeStatus(false);
    setSelectionModal([]);
  };

  return (
    <Box
      className={styles.changeStatusWrapper}
      data-testid="ChangeStatusComponent"
    >
      <Box className={styles.changeStatusInside}>
        <span className={styles.selectText}>
          {i18next.t("You have")}
          <span className={styles.count}>
            {selectionModel?.length < 10
              ? ` (0${selectionModel?.length})`
              : ` (${selectionModel?.length})`}
          </span>
          {i18next.t(" selected dealers")}
        </span>
        <Box className={styles.changeStatusLabelGroup}>
          <span className={styles.selectChangeStatus}>
            {i18next.t("Select new status for selected dealers")}
          </span>
          <Box className={styles.radioGroupWrapper}>
            <FormControl>
              <RadioGroup
                aria-labelledby="status-radio-group"
                defaultValue={""}
                name="status-buttons-group"
                className={styles.radioGroup}
                onChange={(e) =>
                  setSelectedStatus(
                    StatusEnumValue[_.get(e, "target.value", "")]
                  )
                }
              >
                {statusList.map((status, key) => (
                  <FormControlLabel
                    key={status}
                    value={status}
                    control={
                      <Radio
                        icon={<RadioUncheck />}
                        checkedIcon={<RadioIcon />}
                      />
                    }
                    label={
                      <Box>
                        <StatusText
                          textStyle={styles.textStyle}
                          title={status}
                          customClass={getStatusClassName(status)}
                          hasIcon={false}
                          data-testid="status"
                          showPopover={false}
                        />
                      </Box>
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <Box className={styles.changeStatusFooter}>
        <FooterButtonSection
          footerStyle={styles.Detailfooter}
          btnlist={[
            {
              title: "Apply",
              iconStyle: "",
              buttonType: "muibtn-primary",
              attriType: "button",
              withIcon: false,
              showCountSection: false,
              count: 0,
              handleClick: () => handleApply(),
              isDisabled: _.isNull(selectedStatus),
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default ChangeStatusComponent;

ChangeStatusComponent.propTypes = {
  selectionModel: PropTypes.any,
  setSelectionModal: PropTypes.any,
  setBulkActionMenuFlag: PropTypes.any,
  setChangeStatus: PropTypes.any,
  refreshTable: PropTypes.any,
};
